const About = () => {
    return (
      <div className="p-4">
        <h1 className="text-2xl font-bold">The Mission</h1>
        <p className="mt-2">
          We believe that the future of news is collaborative and community-driven...
        </p>
        <h2 className="text-xl font-bold mt-4">Our Team</h2>
        <ul>
          <li>Emily Oster - CEO</li>
          <li>Nicholas Christakis - CTO</li>
          <li>Jenny Odell - Head of Design</li>
          {/* Add others */}
        </ul>
      </div>
    );
  };
  
  export default About;
  